import { BaseAction } from "../base/base.action";

export class CheckoutAction extends BaseAction {
    constructor() {
        super("CHECKOUT")
    }
}


